import APIClient from '../factories/APIClient'
import generateDeviceId from '../../generateDeviceId'
import constructRequestData from '../../constructRequestData'

import attachMock from '../factories/attachMock'
import MOCK_RESPONSES from './Loyalty.mock.json'

const identityClient = new APIClient({
  baseURL: process.env.REACT_APP_IDENTITY_API_BASE_URL,
})

if (process.env.NODE_ENV === 'development') {
  attachMock(
    identityClient,
    MOCK_RESPONSES,
  )({
    // 'get /loyalty/points': 200,
    // 'get /loyalty/transactions/earned': 200,
    // 'get /loyalty/transactions/redeemed': 200,
    // 'get /loyalty/vouchers': 200,
    // 'get /loyalty/vouchers/*': 200,
    // 'post /loyalty/redeem': 200,
  })
}

export const getAllLoyaltyVouchers = ({ active, accessToken }) =>
  identityClient({
    url: `/vouchers?active=${active}`,
    method: 'get',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export const getLoyaltyVoucher = (id, accessToken) =>
  identityClient({
    url: `/vouchers/${encodeURIComponent(id)}`,
    method: 'get',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

//TODO: To check all function below is still being used
export const getLoyaltyPoints = accessToken =>
  identityClient({
    url: '/points',
    method: 'get',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export const getTransactionsEarned = accessToken =>
  identityClient({
    url: '/transactions/earned',
    method: 'get',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export const getTransactionsRedeemed = accessToken =>
  identityClient({
    url: '/transactions/redeemed',
    method: 'get',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export const redeemReward = (rewardId, accessToken) =>
  identityClient({
    url: '/vouchers/redeem',
    method: 'post',
    data: constructRequestData({
      rewardId,
    }),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })
